<ridango-block-full-width *ngIf="!this.redirectedPaymentResult.sessionId">
    <ridango-ui-basic-loading-spinner
        *ngIf="(adyenSession$ | async).sessionLoading || !isAdyenIntegrationReady"
        [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"></ridango-ui-basic-loading-spinner>
    <div id="dropin-container"></div>
</ridango-block-full-width>
